import { css } from "@emotion/react";

export const tableStyle = css`
  overflow: auto;
`;

export const iconStyle = css`
  height: 18px;
  margin-right: 20px;
`;

export const labelStyle = css`
  label {
    font-weight: bold;
  }
`;

export const colGutterStyle = css`
  margin-bottom: 8px;
`;
